import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IdentityProvider, UserData } from '../../../UserProvider/UserData';
import { useCTA } from '../../../hooks/useCTA';
import { useRouter } from '../../../hooks/useRouter';
import { returnVoid } from '../../../util/returnVoid';
import {
  UserAvatarView,
  AvatarInner,
  Sentinel,
  Image,
  Initials,
  AvatarDot,
} from './UserAvatar.styles';
import { UserMenu } from './UserMenu/UserMenu';

export interface Props {
  user: UserData;
  identityProvider?: IdentityProvider;
  onClickLogout?: VoidFunction;
}

export const UserAvatar = ({
  user,
  identityProvider = IdentityProvider.HEALTHENGINE,
  onClickLogout = returnVoid,
}: Props) => {
  const [avatarErrored, setAvatarErrored] = useState(false);
  const [showing, setShowing] = useState(false);
  const { cta } = useCTA();
  const router = useRouter();

  const { t } = useTranslation();

  const handleAvatarError = () => setAvatarErrored(true);

  const handleClickLogout = () => {
    closeMenu();
    onClickLogout();
  };

  const closeMenu = () => setShowing(false);
  const openMenu = () => setShowing(true);
  const toggleMenu = () => setShowing(!showing);

  const avatarLink = user.avatar;

  const showAvatarCTA =
    (cta?.showHealthInterestsCTA || cta?.showNewOfferAddedCTA || cta?.showPrivacyPreferencesCTA) &&
    !router?.pathname.includes('my-account');

  return (
    <UserAvatarView onMouseEnter={openMenu} onMouseLeave={closeMenu}>
      <AvatarInner onClick={toggleMenu}>
        {avatarLink && !avatarErrored && (
          <Sentinel
            alt={t('section.userAvatar.image.description')}
            src={avatarLink}
            onError={handleAvatarError}
          />
        )}

        {avatarLink && !avatarErrored && <Image src={avatarLink} />}

        {(!avatarLink || avatarErrored) && (
          <Initials>
            {user.firstName?.substr(0, 1)}
            {user.lastName?.substr(0, 1)}
          </Initials>
        )}
        {showAvatarCTA && <AvatarDot />}
      </AvatarInner>

      <UserMenu
        showing={showing}
        identityProvider={identityProvider}
        onClickLink={closeMenu}
        onClickLogout={handleClickLogout}
      />
    </UserAvatarView>
  );
};
